import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

import Vant,{Locale,ImagePreview} from 'vant'
import enUS from 'vant/lib/locale/lang/en-US'

import Model from '@/common/Model'
import Dialog from '@/common/Dialog'
import Util from '@/common/Util'

import i18n,{SetLanguage} from './i18n'

import 'vant/lib/index.css'

import '@/assets/css/mi-style.css'

/*兼容*/
import BabelPloyFill from 'babel-polyfill'
import echarts from 'echarts'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import '@/assets/css/config.scss'

import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDH8YFUUZDVF4vuWhR0R6CsFzI6lrNlgfg',  // 替换为你的API密钥
    libraries: 'places,geometry',     // 按需加载库
    language: 'en',                // 中文地图标注
    region: 'US'                      // 区域限制
  },
  installComponents: true             // 自动注册地图组件
})

// import VueFab from 'vue-float-action-button'
// Vue.use(VueFab)
// 移动端适配
// import 'lib-flexible/flexible.js'
Vue.use(VueAwesomeSwiper)
// Vue.use(VueFab, {
//   // opitons 可选iconfont图标或MaterialIcons
//   iconType: 'MaterialDesign'
//   // iconType: 'iconfont'
// })

/*APP*/
Vue.use(Vant)
Vue.prototype.$SetLanguage = SetLanguage
Vue.prototype.$ImagePreview = ImagePreview
Vue.prototype.$Model = Model
Vue.prototype.$Dialog = Dialog
Vue.prototype.$Util = Util
Vue.prototype.$AppInit = false
Vue.prototype.$domWidth = document. documentElement.clientWidth
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
// import '@/icons/index.js'
import Footer from '@/components/Footer'
Vue.component('Footer', Footer)
//金额过滤器
Vue.filter('numFormat', function (value) {
  if (!value) return '0.00'
  var intPart = Number(value).toFixed(2) // 获取整数部分
  var intPartFormat = intPart.replace(/(\d)(?=(\d{3})+\.)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
})

Vue.use(BabelPloyFill)

/*路由登录逻辑*/
router.beforeEach((to, from, next) => {
  document.title = 'SGM'
  if(from.name!='login'&&from.name!='register'){
    localStorage['FromPage'] = from.fullPath;
  }else{
    localStorage.removeItem('FromPage');
  }
  if (to.name!='login'&&!localStorage['Token']&&to.matched.some(record => record.meta.requiresAuth)) {
    next('/login');
  } else {
    next();
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')



